export const ty = 2022

